import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SanitizeService } from '@g99-product-web-ui/shared-service';
import { ReloadIcon, ResetSvgIcon } from '@g99-product-web-ui/shared-util-lib';
@Component({
  selector: 'lib-footer-button',
  templateUrl: './footer-button.component.html',
  styleUrl: './footer-button.component.scss',
  standalone: false,
})
export class FooterButtonComponent {
  @Input() public isFormValid = false; // To handle the form validity
  @Input() public isFormDirty = false; // To handle the form dirty state
  @Input() public saveBtnColor = '';
  @Input() public showCancelBtn = false;
  @Input() public showResetBtn = true;
  @Input() public saveBtnLabel = 'Save Changes';
  @Input() public saveBtnLoadingText = 'Saving...';
  @Input() public resetBtnLabel = 'Reset Changes';
  @Input() public isFormSubmitting = false; // To handle the form submitting state
  @Output() public resetForm = new EventEmitter<void>(); // To emit reset event
  @Output() public saveForm = new EventEmitter<void>(); // To emit save event
  @Output() public cancelForm = new EventEmitter<void>(); // To emit save event
  @Input() public resetIcon = ResetSvgIcon;
  public reloadIcon = ReloadIcon;
  constructor(private readonly _sanitizer: SanitizeService) {}
  public get trustedIcon() {
    return this._sanitizer.sanitizeContent(this.resetIcon);
  }
}
